<template>
  <div class="evaluatePage">
    <div>
      <Card>
        <Row :gutter="24">
          <Col :span="4">
            <DatePickerRange style="width: 100%;" :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" format="YYYY-MM-DD" @change="setDateRange"/>
          </Col>
          <Col :span="4">
            <Button @click="getRateList(1)">搜索</Button>
            <Button type="primary" :loading="exportLoading" :disabled="exportLoading" @click.stop="exportFile" style="margin-left: 12px;">导出</Button>
          </Col>
        </Row>
      </Card>
    </div>
    <div style="margin: 12px 0">
      <Table :loading="listLoading" :dataSource="rateList" :columns="columns" :pagination='false'>
        <template slot="rateStatus" slot-scope="text, record">
          <span v-if="record.rate_score1">满意</span>
           <span v-else style="color:red;">不满意</span>
        </template>
        <template slot="rateStatus2" slot-scope="text, record">
          <span v-if="record.rate_score2">告知</span>
           <span v-else style="color:red;">未告知</span>
        </template>
      </Table>
    </div>
    <Pagination v-model="pageNumber" :pageSize.sync="pageSize" :total="totalRecord" @change="getRateList" />
  </div>
</template>
<script>
import { DatePicker, Button, Row, Col, Card, Table, Pagination } from 'ant-design-vue'
import { isNumber } from 'lodash'
import { toast } from '../../libs/utils'
import moment from 'moment'
import { findCheckRateByPage, downLoadRateFile } from '@/api/user'
export default {
  components: {
    Row,
    Col,
    DatePickerRange: DatePicker.RangePicker,
    Button,
    Card,
    Table,
    Pagination
  },
  data () {
    return {
      columns: [
        {
          title: '患者',
          dataIndex: 'rater_real_name',
          width: 110
        },
        {
          title: '电话',
          dataIndex: 'rater_mobile',
          width: 110
        },
        {
          title: '评价时间',
          dataIndex: 'rate_date',
          width: 110
        },
        {
          title: '评价问题1',
          dataIndex: 'rate_indicator1',
          width: 110
        },
        {
          title: '是否满意',
          scopedSlots: { customRender: 'rateStatus' },
          width: 80
        },
        {
          title: '评价问题2',
          dataIndex: 'rate_indicator2',
          width: 110
        },
        {
          title: '是否告知',
          scopedSlots: { customRender: 'rateStatus2' },
          width: 80
        },
        {
          title: '评价内容',
          dataIndex: 'rate_comment3',
          width: 110
        }
      ],
      rateList: [],
      listLoading: false,
      exportLoading: false,
      startDate: '',
      endDate: '',
      pageNumber: 1,
      pageSize: 10,
      totalRecord: 0
    }
  },
  async mounted () {
    await this.getRateList(1)
  },
  methods: {
    setDateRange (value) {
      if (value.length < 1) {
        this.startDate = ''
        this.endDate = ''
      } else {
        this.startDate = moment(value[0]).format('YYYY-MM-DD')
        this.endDate = moment(value[1]).format('YYYY-MM-DD')
      }
    },
    getSearchParams () {
      const params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        rateType: 10
      }
      if (this.startDate && this.endDate) {
        params.startDate = this.startDate
        params.endDate = this.endDate
      }
      return params
    },
    async getRateList (page) {
      if (this.listLoading) return
      if (isNumber(page)) {
        this.pageNumber = page
      }
      try {
        this.listLoading = true
        const params = this.getSearchParams()
        const data = await findCheckRateByPage(params)
        this.totalRecord = data.totalCount
        this.rateList = data.results || []
      } catch (error) {
        toast({ msg: error.message })
      } finally {
        this.listLoading = false
      }
    },
    async exportFile () {
      if (this.exportLoading) return
      try {
        if (!this.startDate) throw Error('请先选择导出日期范围')
        this.exportLoading = true
        const params = this.getSearchParams()
        await downLoadRateFile(params)
      } catch (error) {
        toast({ msg: error.message })
      } finally {
        this.exportLoading = false
      }
    }
  } 
}
</script>
<style lang="less">
.evaluatePage{
  height: 100%;
  padding-bottom: 24px;
  overflow-y: auto;
  margin: 12px;
  table{
    background-color: #fff;
  }
}
</style>